import { type AxiosInstance } from "axios";
import type { ReuseAcquireRequestPayload } from "@/features/registryChangeAlert/utils/buildReuseAcquireRequest";

/**
 * 変動アラートの新しい登記をリユースで取得する（既存の登記取得依頼 API を使う）。
 * @param {AxiosInstance} apiClient JWT 認証付き apiClient
 * @param {ReuseAcquireRequestPayload} payload 取得依頼
 */
export const PostReuseAcquireAPI = async (
  apiClient: AxiosInstance,
  payload: ReuseAcquireRequestPayload
): Promise<void> => {
  await apiClient.post("/picture-request/", payload);
};
